import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Legal.css'; // Shared CSS with AGB page

function Datenschutz() {
  return (
    <div className="legal-container">
      <div className="legal-content">
        {/* <h1 className="legal-title">Datenschutzerklärung</h1> */}
        <h2>Datenschutzhinweise der INCLASS-App</h2>
        <p>Stand: 19.03.2026</p>
        <h2>1. Verantwortlicher</h2>
        <section className="legal-section">
          <p>
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
            <b>DIPF | Leibniz-Institut für Bildungsforschung und Bildungsinformation</b><br />
            Rostocker Straße 6<br />
            60323 Frankfurt am Main<br />
            Deutschland<br /><br />
            Ansprechperson: Prof. Dr. Florian Schmiedek<br />
            E-Mail: <a href="mailto:datenschutz@gdsm.de">datenschutz@gdsm.de</a><br /><br />
            Kontaktdaten unserer Datenschutzbeauftragten:<br /> 
            Heinz Joachim Eifert<br />
            gds Gesellschaft für Datenschutz Mittelhessen mbH<br />
            Auf der Appeling 8, 35043 Marburg a.d. Lahn<br />
            E-Mail: <a href="mailto:datenschutz@gdsm.de">datenschutz@gdsm.de</a><br /><br />

            Gemäß Artikel 32 DSGVO treffen wir unter Berücksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos für die Rechte und Freiheiten natürlicher Personen geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu gewährleisten.<br />
            Zugleich kann trotz der ergriffenen technischen und organisatorischen Maßnahmen zur Sicherheit der verarbeiteten Daten kein lückenloser Schutz vor unrechtmäßigem Zugriff Dritter garantiert werden.<br /><br />
            Bei Fragen zur Verarbeitung personenbezogener Daten können Sie sich jederzeit an den Verantwortlichen oder die Datenschutzbeauftragte wenden.<br />
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Allgemeine Informationen zur Datenverarbeitung</h2>
          
          Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen der Datenschutz-Grundverordnung (DSGVO) und anderer anwendbarer Datenschutzvorschriften.<br /><br />
          Personenbezogene Daten werden nur verarbeitet, soweit dies für<br />
          
          <ul className="legal-list">
            <li>den Betrieb der INCLASS-App,</li>
            <li>die Bereitstellung ihrer Funktionen,</li>
            <li>die Durchführung wissenschaftlicher Forschung im Bildungsbereich oder</li>
            <li>die Bearbeitung von Anfragen</li>
          </ul>
          erforderlich ist.<br /><br />
          Die Verarbeitung erfolgt insbesondere auf Grundlage von<br />
          <ul className="legal-list">
            <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw. Durchführung vorvertraglicher Maßnahmen),</li>
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung),</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Betrieb, Sicherheit und Weiterentwicklung der App).</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Datenverarbeitung bei Nutzung der INCLASS-App</h2>
          
          Bei der Nutzung der App werden folgende Daten verarbeitet:
          
          <h3>3.1 Registrierungs- und Zugangsdaten</h3>
          
            Zur Nutzung der App wird ein Zugangscode vergeben.<br /><br />
            Dabei werden folgende Daten verarbeitet:
            <ul className="legal-list">
              <li>Zugangscode, wird nach Kontaktaufnahme über ein Kontaktformular bereitgestellt. Dabei werden Name, E-Mail-Adresse, Telefonnummer sowie optional weitere Kontaktinformationen verarbeitet.</li>
              <li>Studiencode (falls Teilnahme an einer Studie erfolgt, d.h. bei Nutzer/innen für die eine informierte Einwilligungserklärung vorliegt)</li>
            </ul>
            Der Zugangscode dient als Pseudonym und ermöglicht die Nutzung der App ohne Angabe identifizierender personenbezogener Daten innerhalb der App.<br /><br />
            Rechtsgrundlage:<br />
            Art. 6 Abs. 1 lit. b DSGVO (Bereitstellung und Nutzung der App).
          

          <h3>3.2 Inhalts- und Nutzungsdaten</h3>
          
            Im Rahmen der Nutzung der App können folgende Daten erhoben werden:<br />
            <ul className="legal-list">
              <li>Angaben zu sensorischen Wahrnehmungen und möglichen Barrieren im Schulalltag (u.a. Barrieren aus verschiedenen Kategorien: auditiv, visuell, taktil etc.)</li>
              <li>Angaben der Nutzer/innen zu ihrem täglichen Befinden im Schulalltag (u.a. Aussagen zustimmen oder ablehnen)</li>
              <li>tägliche Antworten auf standardisierte Fragebögen mit Auswahloptionen (z.B. „stimmt genau“, „stimmt gar nicht“ etc.)</li>
              <li>Datum und Uhrzeit der jeweiligen Einträge</li>
              <li>Angaben zum Profil: Vorname bzw. gewählter Spitzname</li>
              <li>individuell gestalteter Avatar (Monsterfigur), veränderbar (z.B. Körperteile und Farben)</li>
            </ul>
            Die Nutzerinnen und Nutzer werden innerhalb der App nicht zur Eingabe identifizierender personenbezogener Daten (z. B. vollständiger Name, Adresse) aufgefordert.<br /><br />
            Rechtsgrundlage:<br />
            Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) bei Daten, die wissenschaftlich ausgewertet werden (z. B. Befinden im Schulalltag, sensorische Wahrnehmungen) und Art. 6 Abs. 1 lit. b DSGVO bei Daten, die die Appfunktionen betrifft.

          <h3>3.3 Technische Daten</h3>
            Beim Betrieb der App werden technische Daten verarbeitet, die zur sicheren Bereitstellung erforderlich sind:<br />
            <ul className="legal-list">
              <li>temporäre Authentifizierungs-Tokens</li>
              <li>Session-Tokens zur Aufrechterhaltung der Anmeldung</li>
              <li>pseudonyme Nutzerkennung (Zugangscode)</li>
              <li>technische Verbindungsdaten (IP-Adresse, Geräteinformationen, Zeitstempel)</li>
            </ul>
            Diese Daten sind erforderlich, um<br />
            <ul className="legal-list">
              <li>die Funktionsfähigkeit der App sicherzustellen,</li>
              <li>Authentifizierungssitzungen zu verwalten,</li>
              <li>Sicherheitsmechanismen zu gewährleisten.</li>
            </ul>
            Rechtsgrundlage:<br />
            Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am sicheren und stabilen Betrieb der App).
        </section>

        <section className="legal-section">
          <h2>4. Speicherung von Daten auf dem Endgerät</h2>
          
          Bestimmte Daten werden lokal auf dem Endgerät gespeichert, insbesondere:<br />
          
          <ul className="legal-list">
            <li>pseudonymisierte Inhalts- und Nutzungsdaten</li>
            <li>technische Sitzungsinformationen</li>
          </ul>
          Diese Daten werden ausschließlich für den Betrieb der App verwendet.<br /><br />
          Beim Deinstallieren der App werden die lokal gespeicherten Daten gelöscht.<br />
          Rechtsgrundlage:<br />
          Art. 6 Abs. 1 lit. b DSGVO.
        </section>

        <section className="legal-section">
          <h2>5. Verarbeitung von Daten für wissenschaftliche Forschung</h2>
          
          Die INCLASS-App wird im Rahmen wissenschaftlicher Forschungsprojekte in Schulen eingesetzt.<br /><br />
          Die INCLASS-App richtet sich an Schülerinnen und Schüler.<br />
          Sofern Nutzerinnen oder Nutzer das 16. Lebensjahr noch nicht vollendet haben, erfolgt die Verarbeitung personenbezogener Daten im Rahmen von Studien ausschließlich auf Grundlage der Einwilligung der Sorgeberechtigten.<br /><br />
          Rechtsgrundlage:<br />
          Art. 6 Abs. 1 lit. a DSGVO.<br /><br />
          Im Rahmen der Forschung werden insbesondere pseudonymisierte Daten analysiert, z. B.:<br />
          <ul className="legal-list">
            <li>Angaben zu Wahrnehmungen und Barrieren im Schulalltag</li>
            <li>Angaben zum täglichen Befinden</li>
            <li>Nutzungsverhalten innerhalb der App</li>
          </ul>
          Diese Daten dienen der
          <ul className="legal-list">
            <li>wissenschaftlichen Auswertung,</li>
            <li>Weiterentwicklung der App,</li>
            <li>Verbesserung von Maßnahmen zur Unterstützung selbstorganisierten Lernens.</li>
          </ul>

          <h3>5.1 Pseudonymisierung</h3>
            Für Studienteilnehmende wird ein Studiencode verwendet.<br /><br />
            Eine Zuordnung zwischen Studiencode und Identität erfolgt nur über eine gesondert gespeicherte Entblindungsliste.<br />
            Diese Liste wird<br />
            <ul className="legal-list">
              <li>getrennt von den Forschungsdaten gespeichert</li>
              <li>technisch geschützt</li>
              <li>nur von autorisierten Projektmitarbeitenden genutzt.</li>
            </ul>
          <h3>5.2 Zugriff auf Forschungsdaten</h3>
            Zugriff auf die Daten erhalten ausschließlich Projektmitarbeitende des DIPF, die<br />
            <ul className="legal-list">
              <li>an der Entwicklung oder wissenschaftlichen Auswertung beteiligt sind</li>
              <li>zur Vertraulichkeit verpflichtet wurden.</li>
            </ul>
          <h3>5.3 Weitergabe an Forschungsdatenzentren</h3>
            Anonymisierte Forschungsdaten können nach Abschluss der wissenschaftlichen Auswertung an ein Forschungsdatenzentrum des Verbund Forschungsdaten Bildung (VerbundFDB) übermittelt werden.<br /><br />
            Eine solche Weitergabe erfolgt ausschließlich in anonymisierter Form, sodass nach Stand der Technik kein Personenbezug mehr hergestellt werden kann.<br />
        </section>

        <section className="legal-section">
          <h2>6. Auftragsverarbeitung</h2>
          Die technische Bereitstellung der Server erfolgt durch:<br /><br />
          Hetzner Online GmbH<br />
          Industriestraße 25<br />
          91710 Gunzenhausen<br />
          Deutschland<br /><br />
          Die Verarbeitung erfolgt auf Grundlage eines Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO.
        </section>

        <section className="legal-section">
          <h2>7. Kontaktaufnahme</h2>
          Bei der Kontaktaufnahme mit uns per E-Mail oder Telefon werden die uns mitgeteilten Kontaktdaten (z.B. Name, E-Mail-Adresse) von uns gespeichert, um Fragen zu beantworten.<br /><br />
          Rechtsgrundlage:<br />
          Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen).<br /><br />
          Die in diesem Zusammenhang anfallenden Daten löschen wir, nachdem die Speicherung nicht mehr erforderlich ist, oder schränken die Verarbeitung ein, falls gesetzliche Aufbewahrungspflichten bestehen.
        </section>

        <section className="legal-section">
          <h2>8. Datenübermittlung in Drittländer</h2>
          Eine Übermittlung personenbezogener Daten an Staaten außerhalb der Europäischen Union oder an internationale Organisationen findet nicht statt.
        </section>

        <section className="legal-section">
          <h2>9. Hinweis zur Nutzung (App-Stores)</h2>
          Bevor die INCLASS-App auf einem Endgerät genutzt werden kann, benötigt der Nutzende ein Konto des entsprechenden Anbieters 
          (Google Play Store, Apple App Store etc.), über welches die App bezogen werden kann. Auf die Erhebung, Verarbeitung und Nutzung 
          von personenbezogenen Daten im Zusammenhang mit dem jeweiligen App-Store haben wir keinen Einfluss. Die verantwortliche Stelle 
          ist allein der Betreiber des jeweiligen App-Stores. Für die Datenverarbeitungen gelten die jeweiligen Datenschutzbestimmungen 
          des Anbieters. Die Datenschutzbestimmungen der Anbieter sind abrufbar unter:<br /><br />
          Google:<br />
          <a 
            href="https://policies.google.com/privacy" 
            target="_blank"
            rel="noopener noreferrer"
          >
          https://policies.google.com/privacy
          </a><br /><br />
          Apple:<br />
          <a 
            href="https://support.apple.com/de-de/HT208477" 
            target="_blank" 
            rel="noopener noreferrer"
          >
          https://support.apple.com/de-de/HT208477
          </a>
        </section>
        <section className="legal-section">
          <h2>10. Speicherdauer</h2>
          
          Personenbezogene Daten werden nur für den Zeitraum gespeichert und verarbeitet, wie es die bei der Erhebung angegebenen Zwecke erfordern oder 
          solange und soweit Gesetze und Vorschriften dies vorsehen, denen der Verantwortliche unterworfen ist. Entfällt der bei der Erhebung angegebene 
          Zweck, oder laufen gesetzmäßige Speicherfristen ab, werden die gespeicherten Daten gelöscht.<br />
          
          <ul className="legal-list">
            <li>App-Daten werden mit Löschung des Nutzerkontos gelöscht.</li>
            <li>Forschungsbezogene pseudonymisierte Daten werden maximal 3 Jahre gespeichert und anschließend anonymisiert oder gelöscht.</li>
            <li>Die Entblindungsliste wird 24 Monate nach Abschluss der Studie gelöscht.</li>
          </ul>
          Anonymisierte Forschungsdaten können für wissenschaftliche Zwecke langfristig gespeichert werden.
        </section>

        <section className="legal-section">
          <h2>11. Automatisierte Entscheidungsfindung</h2>
          Eine automatisierte Entscheidungsfindung oder Profiling im Sinne von Art. 22 DSGVO findet nicht statt.
        </section>

        <section className="legal-section">
          <h2>12. Rechte der betroffenen Personen</h2>
          
          Nutzerinnen und Nutzer haben nach der DSGVO folgende Rechte:<br />
          
          <ul className="legal-list">
            <li>Art. 15 DSGVO, Recht auf Auskunft</li>
            <li>Art. 16 DSGVO, Recht auf Berichtigung</li>
            <li>Art. 17 DSGVO, Recht auf Löschung</li>
            <li>Art. 18 DSGVO, Recht auf Einschränkung der Verarbeitung</li>
            <li>Art. 17 DSGVO, Recht auf Löschung</li>
            <li>Art. 20 DSGVO, Recht auf Datenübertragbarkeit</li>
          </ul>
          Wenn die Verarbeitung auf einer Einwilligung beruht, kann diese jederzeit mit Wirkung für die Zukunft widerrufen werden.<br /><br />
          Betroffene Personen haben zudem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.<br /><br />
          Die für uns zuständige Aufsichtsbehörde ist der Hessische Beauftragte für Datenschutz und Informationsfreiheit, Gustav-Stresemann-Ring 1, 
          65189 Wiesbaden (ab 16.03.2016: Wilhelmstraße , 65185 Wiesbaden), poststelle@datenschutz.hessen.de. 
        </section>

        <div className="legal-footer">
          {/* <p>Stand: {new Date().toLocaleDateString('de-DE')}</p> */}
          <Link to="/" className="home-link">← Zurück zur Startseite</Link>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;